export default __webpack_public_path__ + "static/media/emoji.79a343fd.png";